import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/index.vue'
import { RouterEnum } from '@/enums/routerEnum'

const Component404 = () => import('@/views/exception/404')

// 主路由
const mainRoutes: RouteRecordRaw = {
	path: '/',
	name: 'Main',
	redirect: RouterEnum.LOGIN_PAGE_PATH,
	component: Layout,
	children: [
		{
			path: RouterEnum.HOME_PAGE_PATH,
			name: 'home',
			component: () => import('@/views/home/index.vue'),
			meta: { title: '首页' },
		},
	],
}

// 基础路由
const baseRoutes: Array<RouteRecordRaw> = [
	{
		path: RouterEnum.LOGIN_PAGE_PATH,
		name: 'login',
		component: () => import('@/views/login/index.vue'),
		meta: { title: '登录' },
	},
]
// 导航路由
const Routes: Array<RouteRecordRaw> = [
	{
		path: `/${RouterEnum.PAGE_403}`,
		name: RouterEnum.PAGE_403,
		component: () => import('@/views/exception/403'),
		meta: { title: RouterEnum.PAGE_403, permission: ['exception'], hidden: true },
	},
	{
		path: `/${RouterEnum.PAGE_404}`,
		name: RouterEnum.PAGE_404,
		component: Component404,
		meta: { title: RouterEnum.PAGE_404, permission: ['exception'], hidden: true },
	},
	{
		path: `/${RouterEnum.PAGE_500}`,
		name: RouterEnum.PAGE_500,
		component: () => import('@/views/exception/500'),
		meta: { title: RouterEnum.PAGE_500, permission: ['exception'], hidden: true },
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'error',
		component: Component404,
		meta: { title: RouterEnum.PAGE_404, hidden: true },
	},
]

export { mainRoutes, baseRoutes, Routes }
